<section class="page-container">
  <div class="flex min-w-0 items-center justify-between gap-4">
    <h1 class="main-heading min-w-0">Sales Consultant Receipt</h1>
    <app-navpath class="hidden md:block" />
  </div>
  <div class="content-container">
    <h2 class="sub-heading w-full border-b">Search</h2>
    <div class="grid grid-cols-1 gap-4 px-4 py-4 md:grid-cols-2">
      <div *ngFor="let field of searchForm" class="flex min-w-0 flex-col gap-2"
           (focusout)="searchCriteria === field.id && searchBuyers()" (keydown.enter)="searchBuyers()">
        <label class="flex items-center gap-2" [for]="'search-' + field.id">
          <input type="radio" name="searchCriteria" [id]="'search-' + field.id" [value]="field.id"
                 [(ngModel)]="searchCriteria" (ngModelChange)="onSearchCriteriaChange()" [disabled]="isSaving || isSearching" />
          {{ field.label }}
        </label>
        <app-text-input class="block w-full" dataType="text" [id]="field.id"
          [dataInput]="field.value || ''" [lock]="!!field.lock || isSaving || isSearching" (dataOutput)="field.value = $event" />
      </div>
    </div>
    <label class="my-4 flex items-center gap-2">
      <input type="checkbox" [(ngModel)]="transferReceipt" [disabled]="!selectedReceipt || isSaving || isSearching" />
      Transfer Receipt
    </label>
  </div>
  <div class="content-container" *ngIf="transferReceipt">
    <h2 class="sub-heading w-full border-b">Transfer Receipt</h2>
    <app-data-form [dataFields]="transferForm" dataName="transferForm" (updateFields_child)="updateTransfer($event)" />
    <div class="flex w-full flex-col gap-1 md:w-fit md:flex-row">
      <button class="shorter-btn save-btn" [disabled]="isSaving || isSearching" (click)="transferItem()">Transfer</button>
      <button class="shorter-btn clear-btn" [disabled]="isSaving" (click)="cancelTransfer()">Cancel</button>
    </div>
  </div>
  <div class="content-container">
    <h2 class="sub-heading w-full border-b">Details Of Buyer</h2>
    <app-data-form [dataFields]="buyerDetailsForm" dataName="buyerDetailsForm" [columns]="2" />
  </div>
  <div class="content-container">
    <h2 class="sub-heading w-full border-b">Details Of Buyer's Receipt</h2>
    <fieldset [disabled]="isSaving || isSearching">
      <div class="grid grid-cols-1 gap-x-8 gap-y-4 px-4 py-4 text-sm md:grid-cols-2 lg:gap-x-14 lg:px-8">
        <div *ngFor="let column of receiptColumns; trackBy: trackReceiptColumn" class="flex min-w-0 flex-col gap-y-4">
          <label *ngFor="let field of column; trackBy: trackReceiptField" class="flex w-full flex-col items-start lg:flex-row">
            <span class="w-full font-bold md:pr-2 lg:w-1/3 lg:pt-2"
                  [class.text-red-warning]="field.required && (field.value == undefined || field.value === '')">
              {{ field.label }}
            </span>
            <div class="w-full min-w-0 lg:w-2/3">
              <app-select-input *ngIf="field.type === 'select'" class="block w-full" [id]="field.id"
                [dataInput]="field.value" [selectOptions]="field.options || []" [required]="!!field.required"
                [lock]="!!field.lock || isSaving || isSearching" (dataOutput)="updateReceiptField(field, $event)" />
              <app-text-input *ngIf="field.type !== 'select' && field.id !== 'amount'" class="block w-full" [id]="field.id"
                [dataType]="field.type" [dataInput]="field.value ?? ''" [required]="!!field.required"
                [lock]="!!field.lock || isSaving || isSearching" [step]="field.step || 0.1"
                [maxLength]="field.maxLength" (dataOutput)="updateReceiptField(field, $event)" />
              <input *ngIf="field.id === 'amount'" type="number" class="receipt-amount-input"
                min="0" step="0.01" required [ngModel]="field.value" [ngModelOptions]="{standalone: true}"
                [disabled]="isSaving || isSearching" (ngModelChange)="updateReceiptField(field, $event)" />
              <span *ngIf="field.id === 'amount' && receiptAmountInWords" class="mt-1 block text-xs" aria-live="polite">
                {{ receiptAmountInWords }}
              </span>
            </div>
          </label>
        </div>
      </div>
    </fieldset>
    <div class="mt-4 flex w-full flex-col flex-wrap gap-1 md:w-fit md:flex-row">
      <button class="shorter-btn misc-btn" [disabled]="isSaving || isSearching || !isReceiptValid()" (click)="addReceipt()">
        <fa-icon [icon]="faPlus" class="mr-1" />Add New Receipt
      </button>
      <button class="shorter-btn misc-btn" [disabled]="isSaving || isSearching" (click)="updateReceipt()">
        <fa-icon [icon]="faPencil" class="mr-1" />Update
      </button>
      <button class="shorter-btn misc-btn" [disabled]="isSaving || isSearching" (click)="deleteReceipt()">
        <fa-icon [icon]="faTrash" class="mr-1" />Delete
      </button>
      <button class="shorter-btn misc-btn" [disabled]="isSaving || isSearching" (click)="printReceipt()">
        <fa-icon [icon]="faPrint" class="mr-1" />Print
      </button>
      <button class="shorter-btn clear-btn" [disabled]="isSaving" (click)="clearReceipt()">
        <fa-icon [icon]="faBan" class="mr-1" />Clear
      </button>
    </div>
  </div>
  <div class="receipt-modal" *ngIf="showDeleteModal" role="dialog" aria-modal="true" aria-labelledby="delete-title">
    <div class="receipt-modal-content content-container">
      <h3 id="delete-title" class="sub-heading mb-4">Delete Receipt</h3>
      <label for="delete-remarks" class="mb-2 block">Delete Remarks</label>
      <app-text-input class="mb-4 block w-full" id="delete-remarks" dataType="text" [dataInput]="deleteRemarks"
                      [required]="true" [lock]="isSaving" (dataOutput)="deleteRemarks = $event || ''" />
      <div class="flex flex-col justify-end gap-2 md:flex-row">
        <button class="shorter-btn delete-btn" [disabled]="isSaving || !deleteRemarks.trim()" (click)="confirmDeleteReceipt()">Delete</button>
        <button class="shorter-btn clear-btn" [disabled]="isSaving" (click)="cancelDelete()">Cancel</button>
      </div>
    </div>
  </div>
  <div class="content-container" *ngIf="tableReceiptEntries.length">
    <h2 class="sub-heading w-full border-b">Listing Of All Unpaid Invoices</h2>
    <div class="w-full overflow-x-auto">
      <app-data-table class="mt-4 block min-w-[80rem]" [tableHeaders]="tableReceiptHeaders"
                      [tableEntries]="tableReceiptEntries" (edit)="editReceipt($event)" />
    </div>
  </div>
</section>
